(function () {
  'use strict';

  var routes = (window.heliora && window.heliora.routes) || {};
  var moneyFormat = (window.heliora && window.heliora.moneyFormat) || '${{amount}}';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-close]')) {
      var mnav = document.getElementById('MobileNav');
      if (mnav) mnav.classList.remove('is-open');
    }
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Product forms ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-product-form]');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var saveEl = root.querySelector('[data-save]');
    var atc = form.querySelector('[data-add-to-cart]');
    var atcText = atc ? atc.querySelector('[data-atc-text]') : null;
    var sticky = document.querySelector('[data-sticky-atc]');

    function selectedOptions() {
      var values = [];
      root.querySelectorAll('[data-option-group]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        values.push(checked ? checked.value : null);
        var label = group.querySelector('[data-option-selected]');
        if (label && checked) label.textContent = checked.value;
      });
      return values;
    }

    function findVariant(values) {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return values[i] === undefined || values[i] === opt; });
      });
    }

    function updateAvailability(values) {
      root.querySelectorAll('[data-option-group]').forEach(function (group, index) {
        group.querySelectorAll('input').forEach(function (input) {
          var test = values.slice();
          test[index] = input.value;
          var match = product.variants.find(function (v) {
            return v.options.every(function (opt, i) { return test[i] === opt; });
          });
          var label = group.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    var planInput = root.querySelector('[data-selling-plan]');
    function selectedPlanId() {
      var checked = root.querySelector('[data-purchase-options] input[type="radio"]:checked');
      return checked && checked.value ? checked.value : '';
    }
    function priceFor(variant) {
      var planId = selectedPlanId();
      if (planId && variant.selling_plan_allocations) {
        var alloc = variant.selling_plan_allocations.find(function (a) { return String(a.selling_plan_id) === String(planId); });
        if (alloc) return { price: alloc.price, compare: alloc.compare_at_price || variant.compare_at_price || variant.price };
      }
      return { price: variant.price, compare: variant.compare_at_price };
    }

    function render(variant) {
      if (!variant) {
        if (atc) atc.disabled = true;
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      var p = priceFor(variant);
      if (planInput) {
        var pid = selectedPlanId();
        planInput.value = pid;
        planInput.disabled = !pid;
      }
      if (priceEl) priceEl.textContent = formatMoney(p.price).replace(/\.00$/, '');
      var onSale = p.compare && p.compare > p.price;
      if (compareEl) {
        compareEl.textContent = onSale ? formatMoney(p.compare).replace(/\.00$/, '') : '';
        compareEl.hidden = !onSale;
      }
      if (saveEl) {
        saveEl.hidden = !onSale;
        if (onSale) saveEl.textContent = 'Save ' + formatMoney(p.compare - p.price).replace(/\.00$/, '');
      }
      if (atc) {
        atc.disabled = !variant.available;
        var label = atc.getAttribute('data-label');
        if (atc.getAttribute('data-price-in-button') === 'true') label += ' \u00b7 ' + formatMoney(p.price).replace(/\.00$/, '');
        if (atcText) atcText.textContent = variant.available ? label : 'Sold out';
      }
      if (sticky) {
        var sp = sticky.querySelector('[data-sticky-price]');
        if (sp) sp.textContent = formatMoney(p.price).replace(/\.00$/, '');
        var sb = sticky.querySelector('[data-sticky-button]');
        if (sb) sb.disabled = !variant.available;
      }
      if (variant.featured_media && variant.featured_media.id) showSlide(root, variant.featured_media.id);
      if (root.hasAttribute('data-update-url') && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-purchase-options]')) { render(findVariant(selectedOptions())); return; }
      if (!e.target.closest('[data-option-group]')) return;
      var values = selectedOptions();
      updateAvailability(values);
      render(findVariant(values));
    });

    var initial = selectedOptions();
    updateAvailability(initial);
    if (root.querySelector('[data-purchase-options]')) render(findVariant(initial));

    /* Quantity */
    root.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        var val = parseInt(input.value, 10) || 1;
        val = btn.hasAttribute('data-plus') ? val + 1 : Math.max(1, val - 1);
        input.value = val;
      });
    });

    /* Gallery thumbs */
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { showSlide(root, thumb.getAttribute('data-thumb')); });
    });

    /* Add to cart */
    form.addEventListener('submit', function (e) {
      if (!document.body.hasAttribute('data-cart-drawer')) return;
      e.preventDefault();
      var errorEl = form.querySelector('[data-form-error]');
      if (errorEl) errorEl.hidden = true;
      if (atc) atc.disabled = true;
      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message || 'Could not add to cart');
          if (data.sections && data.sections['cart-drawer']) replaceDrawer(data.sections['cart-drawer']);
          return refreshCount().then(openDrawer);
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        })
        .finally(function () {
          var v = findVariant(selectedOptions());
          if (atc) atc.disabled = !(v && v.available);
        });
    });

    /* Sticky add to cart */
    if (sticky && atc) {
      var sb = sticky.querySelector('[data-sticky-button]');
      if (sb) sb.addEventListener('click', function () { atc.click(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var below = entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', !entry.isIntersecting && below);
          });
        }).observe(atc);
      }
    }
  }

  function showSlide(root, mediaId) {
    var slides = root.querySelectorAll('[data-slide]');
    if (!slides.length) return;
    var found = false;
    slides.forEach(function (s) {
      var match = s.getAttribute('data-slide') === String(mediaId);
      if (match) found = true;
      s.classList.toggle('is-active', match);
    });
    if (!found) slides[0].classList.add('is-active');
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(mediaId));
    });
  }

  /* ---------- Cart drawer ---------- */
  function openDrawer() { document.body.classList.add('cart-open'); }
  function closeDrawer() { document.body.classList.remove('cart-open'); }

  function replaceDrawer(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-drawer-inner]');
    var current = document.querySelector('[data-drawer-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function refreshCount() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
        return cart;
      });
  }

  function changeLine(line, quantity) {
    var drawer = document.querySelector('.cart-drawer');
    if (drawer) drawer.setAttribute('aria-busy', 'true');
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) replaceDrawer(data.sections['cart-drawer']);
        return refreshCount();
      })
      .finally(function () { if (drawer) drawer.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]') && document.body.hasAttribute('data-cart-drawer')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    var change = e.target.closest('[data-line-change]');
    if (change) {
      changeLine(parseInt(change.getAttribute('data-line'), 10), parseInt(change.getAttribute('data-quantity'), 10));
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  document.querySelectorAll('[data-product-root]').forEach(initProduct);
})();
